import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DonationSettingsSection from "./DonationSettingsSection.vue";
import DonationSettingsCheckboxRow from "./DonationSettingsCheckboxRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsAutoEmissionTab',
    props: {
        mode: {}
    },
    emits: ["update:mode"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsSection, {
                title: _ctx.$t('finance.taxReceipts.settings.autoEmission.title'),
                subtitle: _ctx.$t('finance.taxReceipts.settings.autoEmission.subtitle'),
                "test-id": "donation-settings-auto-emission"
            }, {
                default: _withCtx(() => [
                    _createVNode(DonationSettingsCheckboxRow, {
                        "model-value": __props.mode === 'PerDonation',
                        label: _ctx.$t('finance.taxReceipts.settings.autoEmission.label'),
                        "enabled-help": _ctx.$t('finance.taxReceipts.settings.autoEmission.enabledHelp'),
                        "disabled-help": _ctx.$t('finance.taxReceipts.settings.autoEmission.disabledHelpAnnual'),
                        "test-id": "donation-settings-auto-emission",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:mode', $event ? 'PerDonation' : 'AnnualGrouped')))
                    }, null, 8 /* PROPS */, ["model-value", "label", "enabled-help", "disabled-help"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
